import getConfig from 'next/config'

import { Intent, PaypalClientConfigurationContext } from '@grandvisionhq/payments'

import {
  hasValidTextLength,
  isPostalCode,
  isValidFullName,
  isValidStreetName,
} from '../util/form-validation'

const { publicRuntimeConfig } = getConfig()

const paypal = publicRuntimeConfig.paypal ?? {}

export const getPaypalConfig = (country: string): PaypalClientConfigurationContext => {
  const allowedCountries = ['AT']
  return {
    options: {
      clientId: paypal.clientId,
      disableFunding: paypal.disableFunding,
      intent: Intent.CAPTURE,
      vault: false,
      ...(paypal.environment === 'production' ? {} : { 'buyer-country': country }),
    },
    addressValidation: {
      postalCode: isPostalCode(country),
      hasValidTextLength,
      countryCode: (value: string) => country == value || allowedCountries.includes(value),
      fullName: (value: string): boolean => isValidFullName(value),
      streetName: (value: string): boolean => isValidStreetName(value),
    },
    buttonShape: 'pill',
  }
}
